import { TYPES_TO_EXCLUDE } from "@/constants/search"

const env = import.meta.env

const backendBase = env.VITE_API_BACKEND_BASE

const getEnv = () => {
    return env.VITE_ENVIRONMENT
}

const envType = getEnv()

if (!envType) {
    throw new Error("Could not determine environment type")
}

const getServerUrl = (service: string, env: string) => {
    return `https://${service}-server-${env}.${backendBase}`
}

const getBaseUrl = () => {
    if (env.BASE_URL) {
        return env.BASE_URL
    }

    return `https://${window.location.host}`
}

function getAuthDomain() {
    return window.location.host
}

function getTypesToExclude() {
    try {
        const types = JSON.parse(env.VITE_TYPES_TO_EXCLUDE || "[]")
        if (Array.isArray(types)) {
            return types
        }
    } catch (error) {
        console.error("Error parsing VITE_TYPES_TO_EXCLUDE:", error)
    }

    return TYPES_TO_EXCLUDE
}

const authDomain = getAuthDomain()

export const CONFIGURATION = {
    version: "0.0.1",
    type: envType,
    BASE_URL: getBaseUrl(),
    endpoints: {
        zeno: getServerUrl("zeno", envType),
        studio: getServerUrl("studio", envType),
    },
    API_PATH: `/api/v1`,
    firebase: {
        apiKey: env.VITE_FIREBASE_API_KEY,
        appId: "1:265888598630:web:6e5e76c8ecde887e5afba7",
        authDomain,
        projectId: "dengenlabs",
        providerType: "google"
    },
    TYPES_TO_EXCLUDE: getTypesToExclude(),
}